import React, { useContext } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap";
import { ModeloSite, UsuarioModeloSite } from "../../CentralVendedor";
import Offcanvas from "../components/Offcanvas";
import { useEditarModeloModal } from "./useEditarModeloModal";
import { EmpresaModeloSite } from "../../../../../../common/Empresas/MinhaEmpresa/Sites";
import { InputType } from "reactstrap/lib/Input";
import "./styles.css";
import AuthContext from "../../../../../../../contexts/Auth";

interface EditarModeloModalProps {
  onCloseParams: () => void;
  onCloseModelo: () => void;
  isOpen: boolean;
  _shortUrl?: string;
  usuarioSite: ModeloSite | undefined;
  usuarioUMSId: string | undefined;
  reload: () => Promise<void>;
}

export function EditarModeloModal({
  isOpen,
  onCloseParams,
  onCloseModelo,
  usuarioSite,
  _shortUrl,
  usuarioUMSId,
  reload,
}: EditarModeloModalProps) {
  const { user } = useContext(AuthContext);

  const {
    handleInputChange,
    isFormVisible,
    onSubmit,
    paramsMap,
    setIsFormVisible,
    onParamsPreview,
    iframeURLQueryParams,
    clearParamsPreview,
    handleClose,
    alert,
    isLoading,
    shortUrl,
    handleShortUrlInput,
  } = useEditarModeloModal({
    onCloseParams,
    onCloseModelo,
    usuarioSite,
    usuarioUMSId,
    _shortUrl,
    reload,
    user,
  });

  return (
    <>
      {alert}
      <Modal isOpen={isOpen} toggle={handleClose} style={{ maxWidth: "90%" }}>
        <ModalHeader toggle={handleClose}>Editar Modelo</ModalHeader>
        <ModalBody className="pt-0">
          <div style={{ position: "relative", overflow: "hidden" }}>
            <iframe
              style={{ width: "100%", height: "70vh" }}
              id="myIframe"
              // src={
              //   usuarioSite?.site.tipo_modelo == "vendedor"
              //     ? `http://127.0.0.1:5173/?UMS=${usuarioSite?.id}${iframeURLQueryParams}`
              //     : `http://127.0.0.1:5174/?UMS=${usuarioSite?.id}${iframeURLQueryParams}`
              // }
              src={`${usuarioSite?.link}?UMS=${usuarioUMSId}${iframeURLQueryParams}`}
            ></iframe>
            <Offcanvas
              toggle={() => setIsFormVisible(!isFormVisible)}
              isOpen={isFormVisible}
              onClose={() => setIsFormVisible(!isFormVisible)}
            >
              <Form>
                <FormGroup>
                  <Label>URL do Site</Label>

                  <InputGroup>
                    <InputGroupText>playnee.com/vendedor/?u=</InputGroupText>
                    <Input
                      type="text"
                      name="search"
                      placeholder="nome-do-vendedor"
                      value={shortUrl.value || ""}
                      onChange={handleShortUrlInput}
                    />
                  </InputGroup>
                  <span
                    className="d-flex"
                    style={{
                      gap: ".5rem",
                      alignItems: "center",
                      paddingTop: ".5rem",
                    }}
                  >
                    {shortUrl.isLoading && (
                      <Spinner color="primary" size="sm">
                        Loading...
                      </Spinner>
                    )}
                    {shortUrl.available && !shortUrl.isLoading && (
                      <p style={{ margin: "0", color: "#1e8525" }}>
                        URL Disponível
                      </p>
                    )}
                    {!shortUrl.available && !shortUrl.isLoading && (
                      <p style={{ margin: "0", color: "#851e1e" }}>
                        URL Indisponível
                      </p>
                    )}
                  </span>
                </FormGroup>
              </Form>
              <Form>
                {paramsMap?.map((input) => (
                  <FormGroup key={input.id}>
                    {input.type === "toggle" && (
                      <span
                        className="d-flex align-items-center"
                        style={{
                          justifyContent: "space-between",
                          margin: ".65rem 0",
                        }}
                      >
                        <Label style={{ margin: "0" }}>{input.descricao}</Label>
                        <label className="toggle">
                          <Input
                            type="checkbox"
                            id={input.id.toString()}
                            name={input.chave}
                            onChange={handleInputChange}
                            defaultChecked={input.valor === "true"}
                            data-description={input.descricao}
                          />
                          <label htmlFor={input.id.toString()}></label>
                        </label>
                      </span>
                    )}
                    {(!input.type || input.type === "text") && (
                      <span
                        style={{
                          margin: ".65rem 0",
                        }}
                      >
                        <Label>{input.descricao}</Label>
                        <Input
                          type="text"
                          id={input.id.toString()}
                          name={input.chave}
                          onChange={handleInputChange}
                          defaultValue={input.valor || ""}
                          data-description={input.descricao}
                        />
                      </span>
                    )}
                  </FormGroup>
                ))}
              </Form>
            </Offcanvas>
          </div>

          {/* <div
          style={{
            position: "absolute",
            top: "120px",
            right: "170px",
            width: "40%",
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
          }}
        > */}

          {/* </div> */}

          <ModalFooter
            className="d-flex"
            style={{ padding: "1.5rem 0 0 0", justifyContent: "space-between" }}
          >
            <Button type="button" onClick={onCloseParams}>
              Voltar
            </Button>
            <div
              className="d-flex justify-content-between"
              style={{ width: "350px" }}
            >
              <Button
                style={{ width: "100%", border: "#0847D6 3px solid" }}
                type="button"
                onClick={onParamsPreview}
              >
                Visualizar
              </Button>
              {/* <Button size="sm" type="button" onClick={clearParamsPreview}>Restaurar</Button> */}
              {!isLoading && shortUrl.available ? (
                <Button
                  style={{ width: "100%" }}
                  color="primary"
                  onClick={onSubmit}
                >
                  Salvar
                </Button>
              ) : (
                <>
                  <Button
                    style={{ width: "100%" }}
                    color="primary"
                    onClick={() => {}}
                    disabled={true}
                    active={false}
                    id="save-btn"
                  >
                    Salvar
                  </Button>

                  <UncontrolledTooltip placement="left-end" target={"save-btn"}>
                    Escolha um link de URL válido para prosseguir.
                  </UncontrolledTooltip>
                </>
              )}
            </div>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </>
  );
}
